/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnumDto } from './EnumDto';
import type { PersonDto } from './PersonDto';
export type CardProductionDto = {
    id: string;
    productionNumber: number;
    /**
     * Datetime in string when card production was generated.
     */
    generated: string;
    /**
     * Card count generated in production for STC.
     */
    generatedCardCount: number;
    /**
     * Generated file name.
     */
    fileName: string;
    /**
     * Card count created in STC for production.
     */
    createdCardCount: number;
    /**
     * Card production delivery address.
     */
    delivery: string;
    /**
     * Card production type. "PERSONAL" or "NOT_PERSONAL"
     */
    productionType: CardProductionDto.productionType;
    /**
     * Card types in card production. "PERSONAL", "EXPRESS", "RECLAMATION" etc
     */
    cardType: CardProductionDto.cardType;
    /**
     * Number of file downloads.
     */
    downloadsCount: number;
    employee: PersonDto;
    state: EnumDto;
};
export namespace CardProductionDto {
    /**
     * Card production type. "PERSONAL" or "NOT_PERSONAL"
     */
    export enum productionType {
        PERSONAL = 'PERSONAL',
        NOT_PERSONAL = 'NOT_PERSONAL',
    }
    /**
     * Card types in card production. "PERSONAL", "EXPRESS", "RECLAMATION" etc
     */
    export enum cardType {
        PERSONAL = 'PERSONAL',
        EXPRESS = 'EXPRESS',
        PORTABLE = 'PORTABLE',
        RECLAMATION = 'RECLAMATION',
        EMPLOYEE = 'EMPLOYEE',
    }
}

